import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  SalesDetailCreateRequestDTO,
  SalesDetailUpdateRequestDTO,
  SalesDetailDeleteRequestDTO,
  SalesDetailReadByIdRequestDTO,
  SalesDetailReadByInvoiceIdRequestDTO,
  SalesDetailDTO,
  SalesDetailList,
  SalesDetailReadByItemIdRequestDTO,
  SalesDetailReadByInvoiceIdForImportRequestDTO,
  SalesDetailUpsertBulkRequestDTO
} from './sales-detail.interface';

import {
  SalesDetail_Create,
  SalesDetail_Update,
  SalesDetail_Delete,
  SalesDetail_ReadyById,
  SalesDetail_ReadAll,
  SalesDetail_ReadByInvoiceId,
  SalesDetail_ReadByItemId,
  SalesDetail_ReadByInvoiceIdForImport,
  SalesDetail_UpsertBulk
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class SalesDetailService {

  constructor() { }

  http = inject(HttpClient);

  SalesDetail_Create(data: SalesDetailCreateRequestDTO): Observable<SalesDetailDTO> {
    return this.http.post<SalesDetailDTO>(SalesDetail_Create, data);
  }

  SalesDetail_Update(data: SalesDetailUpdateRequestDTO): Observable<SalesDetailDTO> {
    return this.http.post<SalesDetailDTO>(SalesDetail_Update, data);
  }

  SalesDetail_Delete(data: SalesDetailDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SalesDetail_Delete, data);
  }

  SalesDetail_ReadById(data: SalesDetailReadByIdRequestDTO): Observable<SalesDetailDTO> {
    return this.http.post<SalesDetailDTO>(SalesDetail_ReadyById, data);
  }

  SalesDetail_ReadAll(): Observable<SalesDetailList> {
    return this.http.get<SalesDetailList>(SalesDetail_ReadAll);
  }

  SalesDetail_ReadByInvoiceId(data: SalesDetailReadByInvoiceIdRequestDTO): Observable<SalesDetailList> {
    return this.http.post<SalesDetailList>(SalesDetail_ReadByInvoiceId, data);
  }

  SalesDetail_ReadByItemId(data: SalesDetailReadByItemIdRequestDTO): Observable<SalesDetailList> {
    return this.http.post<SalesDetailList>(SalesDetail_ReadByItemId, data);
  }
  SalesDetail_ReadByInvoiceIdForImport(data: SalesDetailReadByInvoiceIdForImportRequestDTO): Observable<SalesDetailList> {
    return this.http.post<SalesDetailList>(SalesDetail_ReadByInvoiceIdForImport, data);
  }

  SalesDetail_UpsertBulk(data: SalesDetailUpsertBulkRequestDTO): Observable<SalesDetailList> {
    return this.http.post<SalesDetailList>(SalesDetail_UpsertBulk, data);
  }
}
